export function decodeJwtPayload<T = Record<string, unknown>>(
	token: string,
): T | null {
	try {
		const payload = token.split('.')[1];
		if (!payload) return null;
		const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
		const padded = normalized.padEnd(
			normalized.length + ((4 - (normalized.length % 4)) % 4),
			'=',
		);
		const json =
			typeof atob === 'function'
				? atob(padded)
				: Buffer.from(padded, 'base64').toString('utf8');
		return JSON.parse(json) as T;
	} catch {
		return null;
	}
}

export function isJwtExpired(token: string, safetySeconds = 60): boolean {
	const payload = decodeJwtPayload<{ exp?: number }>(token);
	if (!payload || typeof payload.exp !== 'number') return true;
	return payload.exp - safetySeconds <= Math.floor(Date.now() / 1000);
}
